import React from 'react';

import { FormattedMessage, injectIntl, InjectedIntl } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { AutoDismissFlag } from '@atlaskit/flag';
import SuccessIcon from '@atlaskit/icon/glyph/check-circle';
import SimpleTag from '@atlaskit/tag/simple-tag';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import Tooltip from '@atlaskit/tooltip';

import { getCompareBranchesDialogSlice } from 'src/redux/branches';
import { ComponentFlagId } from 'src/redux/flags/types';
import { BucketState } from 'src/types/state';
import { getBranchesFullNames } from 'src/utils/compare-branches';

import messages from './compare-branches-success-flag.i18n';

type Props = {
  id: ComponentFlagId;
  action: 'sync' | 'merge';
  sourceBranchName: string;
  destinationBranchName: string;
  intl: InjectedIntl;
};

const SuccessFlag = ({
  intl,
  id,
  action,
  sourceBranchName,
  destinationBranchName,
  ...otherProps
}: Props) => (
  <AutoDismissFlag
    {...otherProps}
    id={id}
    icon={
      <SuccessIcon
        label="success"
        primaryColor={token('color.icon.success', colors.G300)}
      />
    }
    title={intl.formatMessage(messages[action].compareBranchesSuccessTitle)}
    description={
      <FormattedMessage
        {...messages[action].compareBranchesSuccessDescription}
        values={{
          sourceBranch: (
            <Tooltip content={sourceBranchName} tag="span">
              <SimpleTag text={sourceBranchName} />
            </Tooltip>
          ),
          destinationBranch: (
            <Tooltip content={destinationBranchName} tag="span">
              <SimpleTag text={destinationBranchName} />
            </Tooltip>
          ),
        }}
      />
    }
  />
);

const mapStateToProps = (state: BucketState) => {
  const {
    sourceBranchName,
    destinationBranchName,
    sourceRepositoryFullName,
    destinationRepositoryFullName,
    isMerge,
  } = getCompareBranchesDialogSlice(state);

  const fullNames = getBranchesFullNames(
    sourceBranchName,
    destinationBranchName,
    sourceRepositoryFullName,
    destinationRepositoryFullName
  );

  return {
    action: isMerge ? 'merge' : 'sync',
    sourceBranchName: fullNames.sourceBranchName,
    destinationBranchName: fullNames.destinationBranchName,
  };
};

export const CompareBranchesSuccessFlag = compose<any, any, any>(
  injectIntl,
  connect(mapStateToProps)
)(SuccessFlag);
